export function languageFlag(languageCode: string): string {
  const region = (languageCode.split("-")[1] ?? languageCode).toUpperCase();
  return region.replace(/./g, character => String.fromCodePoint(0x1F1E6 + character.charCodeAt(0) - 65));
}
